module.exports = __webpack_public_path__ + "img/yingyezhizhao.f11660cb.png";